import {
  VehicleExpenseInput,
  VehicleExpensesResponse,
} from "../../types";
import apiClient from "../apiClient";

export const getVehicleExpenses = async (
  vehicleId: string,
): Promise<VehicleExpensesResponse> => {
  const response = await apiClient.get(`vehicle-expenses/vehicle/${vehicleId}`);
  return response.data;
};

export const addVehicleExpense = async (
  params: VehicleExpenseInput & { vehicle_id: string },
) => {
  await apiClient.post("vehicle-expenses/addExpense", params);
};

export const updateVehicleExpense = async (
  params: Partial<VehicleExpenseInput> & { id: string },
) => {
  await apiClient.put("vehicle-expenses/updateExpense", params);
};

export const deleteVehicleExpense = async (id: string) => {
  await apiClient.delete(`vehicle-expenses/removeExpense/${id}`);
};
